import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import {Router, ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-fully-qaulified-address',
  templateUrl: './fully-qaulified-address.component.html',
  styleUrls: ['./fully-qaulified-address.component.css']
})
export class FullyQaulifiedAddressComponent implements OnInit {
  service_address: string;
  constructor(private activatedRoute: ActivatedRoute , private sharedService: SharedService,
    private localStorageService: LocalStorageService, private router: Router) {
     this.sharedService.setHeaderTitle('default_page');
    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
      .then(res => {
          if (res.status === 'success') {
            this.router.navigate(['./dashboard']);
          }
      });
    }else {
      const that = this.sharedService;
      setTimeout(function(){
        that.setHeaderTitle('fully_qualified_address');
      }, 10);
      this.service_address = '' + this.localStorageService.get('service_address');
  }
  }

  ngOnInit() {
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/fully-qaulified-address/fully-qaulified-address.component.ts